import script from "./GroupRoleBranchModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupRoleBranchModal.vue?vue&type=script&setup=true&lang=ts"

import "./GroupRoleBranchModal.vue?vue&type=style&index=0&id=5866c2b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5866c2b6"]])

export default __exports__